module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"LENGTH":"LÄNGE","AREA":"FLÄCHE"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/measuretool/MeasureResult.vue
// module id = azNP
// module chunks = 1